import { render, staticRenderFns } from "./PatientStatusReport.vue?vue&type=template&id=ecd51fc2"
import script from "./PatientStatusReport.vue?vue&type=script&lang=js"
export * from "./PatientStatusReport.vue?vue&type=script&lang=js"
import style0 from "./PatientStatusReport.vue?vue&type=style&index=0&id=ecd51fc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports